/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { colors, Icon, IconProps } from "bold-ui"
import { ReactElement } from "react"
import { Color } from "csstype"

export interface IconTitleProps extends IconProps {
  children: ReactElement
  iconColor: Color
}

export function IconTitle(props: IconTitleProps) {
  const { children, iconColor, ...iconProps } = props

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        justify-items: center;
        padding: 1rem 0;
      `}
    >
      <Icon
        {...iconProps}
        style={css`
          margin-right: 1rem;
          fill: ${iconColor};
        `}
      />
      <h2>{children}</h2>
    </div>
  )
}
